import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark, faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { faBookmark as faBookmarkRegular } from '@fortawesome/free-regular-svg-icons';

const FlashcardsProgress = ({ 
  currentIndex, 
  totalCards, 
  cards,
  isBookmarked, 
  onBookmark,
  onCardSelect,
  theme 
}) => {
  const progress = ((currentIndex + 1) / totalCards) * 100;

  const styles = {
    container: {
      
      borderRadius: '1rem',
      padding: '.5rem',
      
      marginBottom: '.5rem',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '1.5rem',
    },
    cardInfo: {
      display: 'flex',
      alignItems: 'baseline',
      gap: '0.5rem',
    },
    cardNumber: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: theme?.primary?.blue?.[600],
    },
    cardTotal: {
      fontSize: '1rem',
      color: theme?.text?.secondary,
    },
    actions: {
      display: 'flex',
      gap: '1rem',
      alignItems: 'center',
    },
    actionButton: {
      width: '2.5rem',
      height: '2.5rem',
      borderRadius: '0.75rem',
      border: `1px solid ${theme?.borders?.primary}`,
      background: theme?.backgrounds?.secondary,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    progressSection: {
      marginBottom: '1rem',
    },
    progressLabel: {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: '0.875rem',
      color: theme?.text?.secondary,
      marginBottom: '0.5rem',
    },
    progressBarContainer: {
      background: theme?.backgrounds?.secondary,
      borderRadius: '0.5rem',
      height: '0.5rem',
      overflow: 'hidden',
      position: 'relative',
    },
    progressBar: {
      height: '100%',
      background: `linear-gradient(90deg, ${theme?.primary?.amber?.[500] || '#f59e0b'}, ${theme?.primary?.amber?.[600] || '#d97706'})`,
      borderRadius: '0.5rem',
      transition: 'width 0.5s ease',
      position: 'relative',
      overflow: 'hidden',
    },
    progressShine: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
      animation: 'shine 2s infinite',
    },
    cardDots: {
      display: 'flex',
      gap: '0.5rem',
      overflowX: 'auto',
      paddingBottom: '0.5rem',
      scrollbarWidth: 'thin',
    },
    dot: {
      width: '2rem',
      height: '0.5rem',
      borderRadius: '0.25rem',
      background: theme?.backgrounds?.secondary,
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      flexShrink: 0,
    },
    activeDot: {
      background: theme?.primary?.blue?.[600] || '#d97706',
      transform: 'scaleY(1.5)',
    },
    completedDot: {
      background: theme?.primary?.blue?.[300] || '#fcd34d',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.cardInfo}>
          <FontAwesomeIcon 
            icon={faLayerGroup} 
            style={{ 
              color: theme?.primary?.blue?.[600],
              fontSize: '1.25rem',
              marginRight: '0.5rem'
            }} 
          />
          <span style={styles.cardNumber}>Flashard {currentIndex + 1}</span>
          <span style={styles.cardTotal}>of {totalCards}</span>
        </div>
        
        <div style={styles.actions}>
          <motion.button
            style={styles.actionButton}
            whileHover={{ 
              scale: 1.05,
              backgroundColor: theme?.primary?.amber?.[100] || '#fef3c7',
            }}
            whileTap={{ scale: 0.95 }}
            onClick={onBookmark}
          >
            <FontAwesomeIcon 
              icon={isBookmarked ? faBookmark : faBookmarkRegular}
              style={{ 
                color: isBookmarked 
                  ? theme?.primary?.yellow?.[600] || '#d97706'
                  : theme?.primary?.gray?.[600] 
              }}
            />
          </motion.button>
        </div>
      </div>
      
      

      {/* <div style={styles.cardDots}>
        {cards.map((card, index) => (
          <motion.div
            key={index}
            style={{
              ...styles.dot,
              ...(index === currentIndex && styles.activeDot),
              ...(index < currentIndex && styles.completedDot),
            }}
            whileHover={{ scaleY: 1.5 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onCardSelect(index)}
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.02 }}
          />
        ))}
      </div> */}
    </div>
  );
};

export default FlashcardsProgress;